import React from 'react';
import { H2, Text, TextLabel } from 'ds/components/typography';
import {
  TimeStoryItem,
  Content,
  ImageBlock,
  TimeScheduleWrapper,
  DestinationBlock,
  StoryTimeScheduleWrapper,
  Circle,
  NoDestinationTypeBlock,
  GreyStrip,
} from './styled';
import { LimitedText } from 'components/widget/common/styled';
import LocationIcon from 'assets/svg/transportation/location-16.svg';
import { useLocale } from 'locale';
import { transportationTypeToIcons, TimeToGetToProps } from './TimeToGetToItem';
import { CommuteType, commuteTypeDefaultOrder } from 'utils/entities';
import { ShowAt } from 'consts/breakpoints';
import { getHoursAndMinutes } from 'locale/formatDate';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootAction } from 'store/state';
import { CommutePopupStatus } from 'components/commute-popup/types';
import { setCommutePopupStatus } from 'store/state/app/actions';
import { useImageUrlBuilder, ImageOptions } from 'hooks/useImageUrlBuilder';

const IMAGE_OPTIONS: ImageOptions = { height: 300 };
const COMMUTE_IMAGE_PATH = '/address/11091267955_91c3e11345_b.jpg';

interface TimeToGetToStoryProps {
  transportationItem: TimeToGetToProps;
  onShowCommutePopup: () => void;
}

export const TimeToGetToStory: React.FunctionComponent<TimeToGetToStoryProps> = (props) => {
  const { t } = useLocale();
  const { transportationItem, onShowCommutePopup } = props;
  const constructImageURI = useImageUrlBuilder();
  const imgUrl = constructImageURI(transportationItem && transportationItem.imgUrl, IMAGE_OPTIONS);
  const commuteImgUrl = constructImageURI(COMMUTE_IMAGE_PATH, IMAGE_OPTIONS);

  return (
    <TimeStoryItem>
      <Content data-auto="commute-item">
        {transportationItem ?
          (<ImageBlock data-auto="commute-image" imgURL={imgUrl}>
              <DestinationBlock data-auto="commute-destination">
                <TextLabel weight={'bold'} caps>
                  {t('transportationPage.timeToGetTitle')}
                </TextLabel>
                <H2>
                  <ShowAt at={1}>
                    <LimitedText maxWidth={250}>
                      {transportationItem.destination}
                    </LimitedText>
                  </ShowAt>
                  <ShowAt from={2}>
                    <LimitedText maxWidth={400}>
                      {transportationItem.destination}
                    </LimitedText>
                  </ShowAt>
                </H2>
              </DestinationBlock>
            </ImageBlock>
          ) : (
            <ImageBlock imgURL={commuteImgUrl} onClick={onShowCommutePopup}>
              <NoDestinationTypeBlock data-auto="add-commute">
                <LocationIcon/>
                <Text>{t('transportationPage.addYourWorkAddress')}</Text>
              </NoDestinationTypeBlock>
            </ImageBlock>
          )}
        <TimeScheduleWrapper data-auto="commute-time-schedile-wrapper">
          {transportationItem ? (
            commuteTypeDefaultOrder.map((type: CommuteType) => (
              <StoryTimeSchedule
                scheduleType={type}
                scheduleTime={transportationItem.time[type]}
                key={type}
              />
            ))
          ) : (
            commuteTypeDefaultOrder.map((type: string) => (
              <StoryTimeSchedule
                scheduleType={type}
                key={type}
              />
            ))
          )}
        </TimeScheduleWrapper>
      </Content>
    </TimeStoryItem>
  );
};

interface StoryTimeScheduleProps {
  scheduleType: string;
  scheduleTime?: number;
}

const StoryTimeSchedule: React.FunctionComponent <StoryTimeScheduleProps> = (props) => {
  const { scheduleTime , scheduleType } = props;
  const { t } = useLocale();
  return (
    <StoryTimeScheduleWrapper timeExist={!!scheduleTime}>
      <Circle>
        {transportationTypeToIcons[scheduleType]}
      </Circle>
      {scheduleTime
        ? <Text>
            <ShowAt at={1}>
              {t('transportationPage.timeSlotMobile', getHoursAndMinutes(scheduleTime))}
            </ShowAt>
            <ShowAt from={2}>
              {t('transportationPage.timeSlot', getHoursAndMinutes(scheduleTime))}
            </ShowAt>
          </Text>
        : <GreyStrip/>
      }
    </StoryTimeScheduleWrapper>
  );
};

export default connect(null, (dispatch: Dispatch<RootAction>) => ({
  onShowCommutePopup: () => dispatch(setCommutePopupStatus(CommutePopupStatus.Open)),
}))(TimeToGetToStory);
